import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '/imports/ui/Icon';

export interface BreadCrumb {
  path: string, label: string
}

export let setBreadcrumbs: React.Dispatch<React.SetStateAction<BreadCrumb[]>>;

export const BreadCrumbs = () => {
  const [breadcrumbs, _setBreadcrumbs] = useState<BreadCrumb[]>([]);
  setBreadcrumbs = _setBreadcrumbs;
  return (
    <div className="breadcrumbs flex mobile:hidden [&_.icon]:relative [&_.icon]:top-[1px] [&_.icon_svg]:w-4 [&_a]:mx-4 [&_a]:text-grey-2">
      {
        breadcrumbs.map((crumb) => {
          return (
            <div key={crumb.path} className="crumb">
              <Icon icon="chevronRight" />
              <Link to={crumb.path}>{crumb.label}</Link>
            </div>
          );
        })
      }
    </div>
  );
};
